import { render } from "./AdminClientView.vue?vue&type=template&id=21722646"
import script from "./AdminClientView.vue?vue&type=script&lang=js"
export * from "./AdminClientView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__